'use client';

import { useState, useEffect } from 'react';

export const useIsMobile = (
  { width }: { width?: number } = { width: 768 },
): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    // Check if the device is mobile
    const checkIsMobile = () => {
      if (window.innerWidth <= (width ?? 768)) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, [width]);

  return isMobile;
};
